/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'instagram': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M8 4.7C6.2 4.7 4.7 6.2 4.7 8s1.5 3.2 3.2 3.2 3.2-1.5 3.2-3.2S9.8 4.7 8 4.7z"/><path pid="1" d="M15 1.1C14.2.4 13.3 0 12 0H3.9C2.7 0 1.7.4 1 1c-.6.7-1 1.7-1 2.9V12c0 1.2.4 2.2 1.1 2.9.7.7 1.7 1 2.9 1h8c1.2 0 2.2-.4 2.9-1 .7-.7 1.1-1.7 1.1-2.9V4c0-1.2-.4-2.2-1-2.9zM8 13c-2.8 0-5-2.3-5-5 0-2.8 2.3-5 5-5s5.1 2.2 5.1 5-2.3 5-5.1 5zm5.2-9.1c-.7 0-1.2-.5-1.2-1.2s.5-1.2 1.2-1.2 1.2.5 1.2 1.2-.5 1.2-1.2 1.2z"/>'
  }
})
